import React, { useState } from "react";
import { Col, Row, Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

const OrderDetailsScreen = () => {
  const location = useLocation();
  const orderResponse = location.state?.orderResponse;
  // console.log("orderResonse");
  // console.log(orderResponse);
  const orderDetails = Array.isArray(orderResponse?.orderDetails)
    ? orderResponse.orderDetails
    : [];

  // console.log("orderDetails");
  // console.log(orderDetails);
  const { userInfo } = useSelector((state) => state.auth);
  const [selectedItems, setSelectedItems] = useState({
    ...userInfo?.selectedItems,
  });

  return (
    <>
      <div className=" mt-3 text-center">
        {!userInfo?.deliveryTo?.includes("undefined") && (
          <p>Seat - {userInfo?.deliveryTo}</p>
        )}
        Mobile : {orderResponse?.mobileNumber}
        <br />
        <br />
        <br />
        <Row>
          <Col>Order ID : {orderResponse?.orderId}</Col>
          {/* <Col>Mobile : {orderResponse?.mobileNumber}</Col> */}
          <Col>Delivery OTP : {orderResponse?.deliveryOtp}</Col>
        </Row>
        <br />
        <Row
          style={{
            // alignItems: "center",
            justifyContent: "center",
            display: "flex",
            flexDirection: "row",
            width: "100%",
            margin: "1px",
            textAlign: "center",
            // border: "1px solid",
            height: "50vh",
            overflow: "scroll",
            borderRadius: "5px",
          }}
        >
          <Table striped bordered hover>
            <thead className={`${userInfo.themeColor}ThemeThead`}>
              <tr key="table-header"></tr>
              <th>Items</th>
              <th>Price/Item</th>
              <th>Qty</th>
              <th>Tax</th>
              <th>Amount</th>
            </thead>
            <tbody>
              {orderDetails?.map((it) => (
                <tr key={it.itemId}>
                  <td>{it.itemName}</td>

                  <td>
                    <span style={{ textDecoration: "line-through" }}>
                      ₹{it.originalPrice}
                    </span>{" "}
                    ₹
                    {(
                      it.sellingPrice * (1 - it.discountPercent / 100) -
                      it.discountAmount
                    ).toFixed(2)}
                  </td>
                  <td>{it.itemQuantity}</td>
                  <td>
                    {it.gstTax > 0 && (
                      <>
                        {(
                          (it.sellingPriceAfterOffers * it.gstTax) /
                          100
                        ).toFixed(2)}
                        <br />
                        {`${it.gstTax}%`}
                      </>
                    )}
                  </td>
                  <td>{it.sellingPriceAfterOffers + it.gstAmount}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Row>
        <Row>
          <Col>
            Total Amount Paid <br />
            <br />
            <h6 style={{ color: "black" }}>
              ₹ {orderResponse?.grossTotal}|{" "}
              {orderDetails?.reduce((total, it) => total + it.itemQuantity, 0)}{" "}
              Items
            </h6>
          </Col>
        </Row>
        <br />
        {orderResponse?.createdAt ? (
          <>
            Date :{" "}
            {new Date(
              new Date(orderResponse.createdAt).getTime() + 5 * 60 * 60 * 1000
            )
              .toISOString()
              .slice(0, 10)}{" "}
            {new Date(
              new Date(orderResponse.createdAt).getTime() + 5 * 60 * 60 * 1000
            )
              .toISOString()
              .slice(11, 16)}
          </>
        ) : (
          "Date not available"
        )}
      </div>
    </>
  );
};

export default OrderDetailsScreen;
